// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e0f08d4a","496":"a692bdbb","605":"aa820be1"}[chunkId] + ".chunk.js";
};